import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=78389895&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78389895')) {
      api.createRecord('78389895', component.options)
    } else {
      api.reload('78389895', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=78389895&", function () {
      api.rerender('78389895', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2F8Ue4Qyy7Wvo/JS/comp/childrenage.vue"
export default component.exports